import Mutation from './mutationTypes';
import { apiGetLawlexAddonStatus, apiAddToIpdLog } from "../api";
import { LAWLEX_STATUS_TRUE, LAWLEX_STATUS_FALSE } from '../constant';

export default {
  setItem: ({ commit }, { field, value }) => {
    commit(Mutation.SET_ITEM, { field, value });
  },
  initNineDots: async ({ commit, getters }) => {
    try {
      commit(Mutation.SET_ITEM, { field: 'showModal', value: !getters.getItem('showModal') });
    } catch (error) {
      commit(Mutation.SET_ITEM, { field: 'showModal', value: false });
      console.log(error);
    }
  },

  loadLawlexApi: async ({ commit }) => {
    try {
      //call api
      commit(Mutation.SET_ITEM, { field: 'showLawlexLockIcon', value: false});
      commit(Mutation.SET_ITEM, { field: 'lawlexLoading', value: true});
      const response = await apiGetLawlexAddonStatus();
      const isLawlexEnabled = response == 'true';
      commit(Mutation.SET_ITEM, { field: 'lawlexApiLoaded', value: isLawlexEnabled ? LAWLEX_STATUS_TRUE : LAWLEX_STATUS_FALSE});
      commit(Mutation.SET_ITEM, { field: 'showLawlexLockIcon', value: isLawlexEnabled});
      commit(Mutation.SET_ITEM, { field: 'lawlexLoading', value: false});
    } catch (error) {
      console.error('Failed to load Lawlex status from store:', error);
      commit(Mutation.SET_ITEM, { field: 'lawlexApiLoaded', value: LAWLEX_STATUS_FALSE});
      commit(Mutation.SET_ITEM, { field: 'loadingApi', value: false});
    }
  },

  closeNineDots:  ({ commit }) => {
    commit(Mutation.SET_ITEM, {field: 'showModal', value: false});
  },

  addToIpdLog: async (context, payload) => {
    try {
      const { moduleName, linkClicked } = payload;
      await apiAddToIpdLog(moduleName, linkClicked);
    } catch (error) {
      console.error('Failed to add to Ipd log:', error);
    }
  }
};

